import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '82b9d8345b387738b7509a3d6f98a567.png',
	fr: 'e890d66a7c3ed948cbd54aacad6b4505.png',
};

export const SongcatcherName: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			imagePosition="left"
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'songcatcherlandingpage_title_whatsthenameofthissong_standalone-web',
							{ns: 'songcatcher'},
						)}{' '}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'songcatcherlandingpage_text_whatsthenameofthissong_standalone-web',
							{ns: 'songcatcher'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					sizes={{base: '100vw', md: '50vw', lg: '48vw'}}
					h={{base: '300px', md: '100%'}}
					aspectRatio="1440/840"
					quality={90}
					src={src}
					alt={t('metatag_text_identifymusicwithsongcatcher_standalone-web', {
						ns: 'common',
					})}
				/>
			}
		/>
	);
};
